import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import SearchBooks from '../../Ebook/Books/components/SearchBooks/SearchBooks'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import { BlockHeader } from 'components/UI/BlockHeader/BlockHeader'
import styles from './LatestActionPage.module.scss'
import { Link, useHistory } from 'react-router-dom'
import { superAxiosRequest } from 'axiosApi'
import { localisationMaster } from 'Localisation/Localisation'
import { dateFormat } from 'helpers/date'
import Stores from 'Stores'
import useLocalization from 'hooks/useLocalization'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import listingStore from 'Stores/listingStore'
import Pagination from 'components/UI/Pagination/Pagination'
import useUrlParams from 'hooks/useUrlParams'
import { addZero } from 'helpers/math'

const getOperation = (op) => {
  let rows = []

  const cud = () =>
    Object.keys(op.old).length === 0
      ? 1
      : Object.keys(op.new).length === 0
        ? -1
        : 0

  const schedule = (sch) => {
    const rows = []

    sch.start_at &&
      sch.finish_at &&
      rows.push(`
            ${sch.start_at.slice(0, 5)} - ${sch.finish_at.slice(0, 5)} 
            ${
              sch.hours_per_day
                ? ` (${+sch.hours_per_day} ${
                    +sch.hour_type_id === 1
                      ? localisationMaster('ac_h', 'groups/group')
                      : localisationMaster('astr_h', 'groups/group')
                  })`
                : ''
            }`)

    sch.date_from &&
      sch.date_until &&
      rows.push(
        `${dateFormat(new Date(sch.date_from), 'dd MMM YYYY')} ${localisationMaster('yr', 'groups/group')} - ${dateFormat(new Date(sch.date_until), 'dd MMM YYYY')} ${localisationMaster('yr', 'groups/group')}`,
      )

    sch.hours_total &&
      rows.push(
        `${localisationMaster('text_1', 'groups/group', 'group_log')}: ${+sch.hours_total} ${+sch.hour_type_id === 1 ? localisationMaster('ac_h', 'groups/group') : localisationMaster('astr_h', 'groups/group')}`,
      )

    Array.isArray(sch.teachers_name) &&
      rows.push(
        `${localisationMaster('text_2', 'groups/group', 'group_log')}: ${Stores.transliterate(`${sch.teachers_name.join(', ')}`)}`,
      )

    sch.classroom_name &&
      rows.push(
        `${localisationMaster('text_3', 'groups/group', 'group_log')}: ${sch.classroom_name}`,
      )

    return rows
  }

  try {
    switch (op.operation_type) {
      // Расписания
      case 'schedule':
        rows.push(
          `${
            cud() === 1
              ? localisationMaster('add', 'groups/group', 'group_log')
              : cud() === -1
                ? localisationMaster('removed', 'groups/group', 'group_log')
                : localisationMaster('changed', 'groups/group', 'group_log')
          } ${localisationMaster('text_5', 'groups/group', 'group_log')}`,
        )
        if (cud() === 0) {
          rows.push(
            `${localisationMaster('text_6', 'groups/group', 'group_log')}:`,
          )
          rows = rows.concat(
            schedule(op.old).map(
              (r) =>
                `${localisationMaster('text_9', 'groups/group', 'group_log')}: ${r}`,
            ),
          )
          rows = rows.concat(
            schedule(op.new).map(
              (r) =>
                `${localisationMaster('text_10', 'groups/group', 'group_log')}: ${r}`,
            ),
          )
        }
        break
      case 'workshop':
        rows.push(
          `${
            cud() === 1
              ? localisationMaster('add', 'groups/group', 'group_log')
              : cud() === -1
                ? localisationMaster('removed', 'groups/group', 'group_log')
                : localisationMaster('changed', 'groups/group', 'group_log')
          } ${localisationMaster('text_5', 'groups/group', 'group_log')}`,
        )

        const formatTime = (time) => time.slice(0, 5)

        if (cud() === 1) {
          rows = rows.concat(schedule(op.new))
        } else if (cud() === 0) {
          rows.push(
            `${localisationMaster('text_6', 'groups/group', 'group_log')}:`,
          )
          if (op.old.start_at && op.old.finish_at) {
            rows.push(
              `${localisationMaster('text_9', 'groups/group', 'group_log')}: ${formatTime(op.old.start_at)} - ${formatTime(op.old.finish_at)}`,
            )
          }
          if (op.new.start_at && op.new.finish_at) {
            rows.push(
              `${localisationMaster('text_10', 'groups/group', 'group_log')}: ${formatTime(op.new.start_at)} - ${formatTime(op.new.finish_at)}`,
            )
          }
        } else {
          rows = rows.concat(schedule(op.old))
        }
        break
      // Группа
      case 'name':
      case 'location':
      case 'company':
      case 'number':
      case 'status':
      case 'discipline':
      case 'type':
      case 'size':
      case 'doc_type':
      case 'doc_type_description':
      case 'course_level':
      case 'skill_level':
      case 'default_price':
        const whats = {
          name: localisationMaster('text_19', 'groups/group', 'group_log'),
          location: localisationMaster('text_20', 'groups/group', 'group_log'),
          company: localisationMaster('text_21', 'groups/group', 'group_log'),
          number: localisationMaster('text_22', 'groups/group', 'group_log'),
          status: localisationMaster('text_23', 'groups/group', 'group_log'),
          discipline: localisationMaster(
            'text_24',
            'groups/group',
            'group_log',
          ),
          type: localisationMaster('text_25', 'groups/group', 'group_log'),
          size: localisationMaster('text_26', 'groups/group', 'group_log'),
          doc_type: localisationMaster('text_27', 'groups/group', 'group_log'),
          course_level: localisationMaster(
            'text_28',
            'groups/group',
            'group_log',
          ),
          skill_level: localisationMaster(
            'text_29',
            'groups/group',
            'group_log',
          ),
          comment: localisationMaster('text_30', 'groups/group', 'group_log'),
          default_price: localisationMaster(
            'text_31',
            'groups/group',
            'group_log',
          ),
        }

        if (cud() === 1) {
          rows.push(
            `${localisationMaster('text_18', 'groups/group', 'group_log')}:`,
          )
        } else {
          rows.push(
            `${localisationMaster('text_17', 'groups/group', 'group_log')}: ${whats[op.operation_type]}`,
          )
          rows.push(
            `${localisationMaster('text_9', 'groups/group', 'group_log')}: ${op.old[op.operation_type]}`,
          )
          rows.push(
            `${localisationMaster('text_10', 'groups/group', 'group_log')}: ${op.new[op.operation_type]}`,
          )
        }
        break
      // Комментарий к группе (м.б. с тегами)
      case 'comment':
        const what = localisationMaster('text_30', 'groups/group', 'group_log')

        if (cud() === 1) {
          rows.push(
            `${localisationMaster('text_18', 'groups/group', 'group_log')}:`,
          )
        } else {
          rows.push(
            `${localisationMaster('text_17', 'groups/group', 'group_log')}: ${what}`,
          )
          rows.push(
            `${localisationMaster('text_9', 'groups/group', 'group_log')}: ${op.old.comment}`,
          )
          rows.push(
            `${localisationMaster('text_10', 'groups/group', 'group_log')}: ${op.new.comment}`,
          )
        }
        break
      // Студенты
      case 'new_client':
        rows.push(
          `${localisationMaster('add_2', 'groups/group', 'group_log')}  ${Stores.transliterate(`${op.new.client_name}`)}`,
        )
        break
      case 'student_default_price':
        rows.push(
          `${cud() === 1 ? localisationMaster('add_1', 'groups/group', 'group_log') : cud() === -1 ? localisationMaster('removed_1', 'groups/group', 'group_log') : localisationMaster('changed_1', 'groups/group', 'group_log')} ${localisationMaster('text_8', 'groups/group', 'group_log')}: ${Stores.transliterate(`${op.new.student_name || op.old.student_name}`)}`,
        )
        break
      case 'student_discounts':
        rows.push(
          `${cud() === 1 ? localisationMaster('add_1', 'groups/group', 'group_log') : cud() === -1 ? localisationMaster('removed_1', 'groups/group', 'group_log') : localisationMaster('changed_1', 'groups/group', 'group_log')} ${localisationMaster('text_9', 'groups/group', 'group_log')}: ${Stores.transliterate(`${op.new.student_name || op.old.student_name}`)}`,
        )
        break
      case 'student_surcharges':
        rows.push(
          `${cud() === 1 ? localisationMaster('add_1', 'groups/group', 'group_log') : cud() === -1 ? localisationMaster('removed_1', 'groups/group', 'group_log') : localisationMaster('changed_1', 'groups/group', 'group_log')} ${localisationMaster('text_9', 'groups/group', 'group_log')}: ${Stores.transliterate(`${op.new.student_name || op.old.student_name}`)}`,
        )
        break
      case 'client_status':
        rows.push(
          `${localisationMaster('text_11', 'groups/group', 'group_log')}: ${Stores.transliterate(`${op.new.client_name}`)}`,
        )
        break
      case 'client_study_dates':
        rows.push(
          `${localisationMaster('text_12', 'groups/group', 'group_log')}: ${Stores.transliterate(`${op.new.client_name}`)}`,
        )
        break
      // Статусы преподавателей
      case 'teacher_status':
        rows.push(
          `${cud() === 1 ? localisationMaster('set', 'groups/group', 'group_log') : cud() === -1 ? localisationMaster('removed_2', 'groups/group', 'group_log') : localisationMaster('changed_2', 'groups/group', 'group_log')} ${localisationMaster('text_15', 'groups/group', 'group_log')}: ${dateFormat(new Date(op.new.date), 'dd MMM YYYY')} ${localisationMaster('yr', 'groups/group')}`,
        )
        break
      // Статусы студентов
      case 'student_status':
        rows.push(
          `${cud() === 1 ? localisationMaster('set', 'groups/group', 'group_log') : cud() === -1 ? localisationMaster('removed_2', 'groups/group', 'group_log') : localisationMaster('changed_2', 'groups/group', 'group_log')} ${localisationMaster('text_16', 'groups/group', 'group_log')}: ${Stores.transliterate(`${op.new.student_name}`)}, ${dateFormat(new Date(op.new.date), 'dd MMM YYYY')} ${localisationMaster('yr', 'groups/group')}`,
        )
        break
      default:
        break
      case 'workshop_teacher_replace':
        rows.push(
          `${localisationMaster('changed', 'groups/group', 'group_log')} ${localisationMaster('text_5', 'groups/group', 'group_log')}`,
        )
        if (op.new && op.new.group_name) {
          rows.push(
            `${localisationMaster('text_7', 'groups/group', 'group_log')}: ${Stores.transliterate(op.new.group_name)}`,
          )
        }
        break
      case 'workshop_transfer':
        rows.push(
          `${localisationMaster('changed', 'groups/group', 'group_log')} ${localisationMaster('text_5', 'groups/group', 'group_log')}`,
        )
        if (op.new && op.new.group_name) {
          rows.push(
            `${localisationMaster('text_7', 'groups/group', 'group_log')}: ${Stores.transliterate(op.new.group_name)}`,
          )
        }
        break
    }
  } catch (e) {
    rows.push(e.toString())
  }

  return rows
}
function dateFormatForLatestAction(oDate = new Date(), format = 'dd.mm.YYYY') {
  try {
    if (typeof oDate === 'string' || typeof oDate === 'number') {
      oDate = new Date(oDate)
      oDate = new Date(
        Date.UTC(
          oDate.getUTCFullYear(),
          oDate.getUTCMonth(),
          oDate.getUTCDate(),
          oDate.getUTCHours(),
          oDate.getUTCMinutes(),
          oDate.getUTCSeconds(),
        ),
      )
    }
    // Массив месяцев для локализации
    const months = [
      localisationMaster('months_1', 'months'),
      localisationMaster('months_2', 'months'),
      localisationMaster('months_3', 'months'),
      localisationMaster('months_4', 'months'),
      localisationMaster('months_5', 'months'),
      localisationMaster('months_6', 'months'),
      localisationMaster('months_7', 'months'),
      localisationMaster('months_8', 'months'),
      localisationMaster('months_9', 'months'),
      localisationMaster('months_10', 'months'),
      localisationMaster('months_11', 'months'),
      localisationMaster('months_12', 'months'),
    ]

    // Форматирование даты
    format = format
      .replace('dd', addZero(oDate.getUTCDate()))
      .replace('d', oDate.getUTCDate())
      .replace('mm', addZero(oDate.getUTCMonth() + 1))
      .replace('MMMM', months[oDate.getUTCMonth()].toLowerCase())
      .replace('MMM', months[oDate.getUTCMonth()])
      .replace('YYYY', oDate.getUTCFullYear())
      .replace('YY', String(oDate.getUTCFullYear()).slice(2))
      .replace('hh', addZero(oDate.getUTCHours()))
      .replace('ii', addZero(oDate.getUTCMinutes()))
      .replace('ss', addZero(oDate.getUTCSeconds()))
    return format
  } catch (e) {
    return 'Invalid date'
  }
}

const LatestActionPage = ({ userId }) => {
  const {
    page,
    perPage,
    setPage,
    setPerPage,
    data,
    setFilterParams,
    filterType,
    setFilterType,
    loading,
  } = listingStore
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const [logData, setLogData] = useState([])
  const [logsToShow, setLogsToShow] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [filter, updateFilter] = useLocalStorageFilter()

  const [gc, setgc] = useState([false, []])
  const [dropped, setDropped] = useState(false)
  const [listing, setListing] = useState(null)
  const { urlParams, setAllParams } = useUrlParams()
  const history = useHistory()

  const { translate } = useLocalization({
    section: 'profile',
    subsection: 'latest_actions',
    dict: {
      title: 'Latest actions',
      group_name_or_number: 'Search for a Group by Name or Number',
      search_input: 'Search for a group by name or number...',
      date: 'Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      filter: 'Filter',
      page: 'Page',
      of: 'of',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })

  const config = [
    {
      nameState: 'group_name',
      placeholder: translate.group_name_or_number,
      type: 'input',
      label: translate?.group_name_or_number,
    },
    {
      type: 'date_day_picker',
      nameState: ['date_from', 'date_until'],
      label: translate?.date,
    },
  ]
  const formatDate = (dateString) => {
    const newTimeString = [...dateString].slice(0, -1).join('')
    const months = [
      'Января',
      'Февраля',
      'Марта',
      'Апреля',
      'Мая',
      'Июня',
      'Июля',
      'Августа',
      'Сентября',
      'Октября',
      'Ноября',
      'Декабря',
    ]

    const date = new Date(newTimeString)
    const day = date.getDate()
    const monthIndex = date.getMonth()
    const year = date.getFullYear()

    return `${day} ${months[monthIndex]} ${year} г.`
  }
  const formatDateTime = (dateTimeString) => {
    const newTimeString = [...dateTimeString].slice(0, -1).join('')
    const date = new Date(newTimeString)
    const options = { hour: '2-digit', minute: '2-digit' }
    return date.toLocaleTimeString('ru-RU', options)
  }

  useEffect(() => {
    if (filter?.date_from && filter?.date_until) {
      setLogsToShow(
        logData
          .filter(
            (log) =>
              new Date(log.updated_at).getTime() >
              new Date(filter?.date_from).getTime(),
          )
          .filter(
            (log) =>
              new Date(log.updated_at).getTime() <
              new Date(filter?.date_until).getTime(),
          ),
      )
    } else {
      setLogsToShow(logData)
    }
  }, [filter?.date_from, filter?.date_until, logData])

  useEffect(() => {
    setLogsToShow(
      logData.filter(
        (log) =>
          log.group_data.name
            ?.toLowerCase()
            ?.includes(filter?.name_number?.toLowerCase()) ||
          log.group_data?.number
            ?.toLowerCase()
            ?.includes(filter?.name_number?.toLowerCase()),
      ),
    )
  }, [filter?.name_number, logData])

  useEffect(() => {
    if (data) {
      setLogsToShow(data)
    }
  }, [data])

  const changeListing = () => setListing(new Date())

  useEffect(() => {
    setDropped(true)
    if (urlParams) {
      Object.keys(urlParams).forEach((key) =>
        setFilterParams(urlParams[key], key),
      )
      urlParams?.limit && setPerPage(urlParams?.limit)
      // urlParams?.filter_type && setFilterType(urlParams.filter_type);
      if (+urlParams?.offset) {
        // Здесь вычисляем на какой странице сохранился пагинация.
        urlParams?.offset &&
          setPage(urlParams?.offset / (urlParams?.limit || perPage) + 1)
      }
    }
    changeListing()

    if (!gc[0]) {
      let apiConf = {
        method: 'get',
        link: 'groups/groups_catalog',
        headers: {
          'accept-language':
            'en,ru;q=0.9,de;q=0.8,en-US;q=0.7,ru-RU;q=0.6,kk;q=0.5',
        },
      }
      superAxiosRequest(apiConf).then((res) => setgc([true, res.data]))
    }

    return () => {
      listingStore.dropData()
      AsideFilterStore.unmountFilter()
    }
  }, [])

  useEffect(() => {
    if (listing === null) return

    let params = {
      ...filter,
      offset: (page - 1) * perPage,
      limit: perPage,
    }

    const operation_id = logsToShow?.[0]?.['operation_id']?.['operation_id']
    if ((page - 1) * perPage !== 0 && operation_id) {
      params = {
        ...params,
        next_page: 'True',
        operation_id: operation_id,
      }
    }
    const apiConf = {
      method: 'get',
      link: 'logs/action_history',
      params,
    }

    const unlisten = history.listen((location) => {
      if (location.pathname !== '/latest') {
        updateFilter({})
      }
    })

    setAllParams(params)
    listingStore.fillData(apiConf)
    setIsLoading(false)

    return () => {
      unlisten()
    }
  }, [listing, page, perPage, filter, filterType])

  return (
    <div className={styles.groupContainer}>
      {isLoading || loading ? (
        <Loader />
      ) : (
        <>
          <BlockHeader title={translate?.title}></BlockHeader>
          <div className={styles.search}>
            <SearchBooks
              onSearch={(text) => {
                updateFilter({ ...filter, group_name: text })
                changeTextValue('group_name', {
                  key: 'group_name',
                  label: translate?.group_name_or_number,
                  value: text,
                })
              }}
              onClear={() => {
                const { group_name, ...obj } = filter
                updateFilter(obj)
                setTextValues(
                  filterTextValues.filter(
                    (field) => field.key !== 'group_name',
                  ),
                )
              }}
              value={filter?.group_name || ''}
              translate={translate}
              placeholder={translate?.search_input}
            />
            {!!filterTextValues.length && (
              <FilterTextValues
                onDelete={(key) => {
                  const { [key]: _, ...obj } = filter
                  updateFilter(obj)
                }}
              />
            )}

            {isOpenFilter && (
              <AsideFilter
                translate={translate}
                getFilterParams={(e) => {
                  updateFilter(e)
                  setPage(1)
                }}
                config={config}
                filterValue={filter}
                onDropFilter={() => {
                  updateFilter({})
                  closeFilter()
                }}
              />
            )}
          </div>
          <div className={styles.mapedLogContent}>
            {Array.isArray(logsToShow) &&
              logsToShow.map((log, index) => (
                <div
                  key={index}
                  className={`${styles.logItem}  ${index % 2 === 0 ? styles.logContentColored : ''}   `}
                >
                  <div className={styles.logContent}>
                    <div className={styles.maping}>
                      {getOperation(log).map((r, idx) =>
                        log.operation_type === 'comment' ? (
                          <div
                            className={styles.logTopic}
                            key={idx}
                            dangerouslySetInnerHTML={{ __html: r }}
                          />
                        ) : (
                          <div className={styles.logUserRole} key={idx}>
                            {r}
                          </div>
                        ),
                      )}
                      <div
                        className={`${styles.groupName} ${styles.hiddenContent}`}
                      >
                        <Link
                          target='_blank'
                          to={`/groups/group/${log.group_data.id}`}
                        >
                          <span>{log.group_data.number}</span>
                          <span> {' - '} </span>
                          <span>{log.group_data.name}</span>
                        </Link>
                      </div>
                    </div>
                    <div
                      className={`${styles.groupName} ${styles.hiddenGroupContent}`}
                    >
                      <Link
                        target='_blank'
                        to={`/groups/group/${log.group_data.id}`}
                      >
                        <span>{log.group_data.number}</span>
                        <span> {' - '} </span>
                        <span>{log.group_data.name}</span>
                      </Link>
                    </div>
                    <div className={styles.timeAndDate}>
                      <div className={styles.logTime}>
                        {formatDateTime(log.updated_at)}
                      </div>
                      <div className={styles.logSecondDate}>
                        {dateFormat(log.updated_at, 'd MMMM YYYY')}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            <div className={styles.pagination}>
              <Pagination
                translate={translate}
                limit={+perPage}
                count={listingStore.meta.count_items || 5}
                page={page}
                onChange={setPage}
                onChangePerPage={setPerPage}
              />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default observer(LatestActionPage)
